import store from "../../../../../store";
import { has, have } from "../../../../../utils/menu-context";
import lodash from "lodash";

export const commonInputPropField = ({ disabledStatuses, disabledRequestTypes }) => ({ modelRef, initialModel }) => {
    let enabled = undefined;
    if (disabledStatuses?.includes(initialModel.refStatus?.key) || disabledRequestTypes?.includes(modelRef.refRequestType?.key)) {
        enabled = false;
    }
    return { disabled: enabled !== undefined ? !enabled : undefined };
};

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext, routerPrefix } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (routerPrefix === "release-results") {
                if (record.createBy === store.state.resource.auth.info.user?.username) {
                    if ([undefined, "draft"].includes(record.refStatus?.key)) {
                        result = true || result;
                    }
                }
                if (has({ menuContext, key: "forReceive" })) {
                    if (["waitReleaseResult", "reEditAuthority"].includes(record.refStatus?.key)) {
                        result = true || result;
                    }
                }

            }
            if (["release-requests", "releases"].includes(routerPrefix)) {
                if (has({ menuContext, key: "forReceive" })) {
                    if (["waitRelease", "reEditAuthority"].includes(record.refStatus?.key)) {
                        result = true || result;
                    }
                }
                if (has({ menuContext, key: "forApprove" })) {
                    if (["waitReceive", "waitApprove"].includes(record.refStatus?.key)) {
                        result = true || result;
                    }
                }
            }
            if (routerPrefix === "release-cancels") {
                if (has({ menuContext, key: "forRequest" })) {
                    if (["draft", "reEditAuthority"].includes(record.refStatus?.key)) {
                        result = true || result;
                    }
                }
                if (has({ menuContext, key: "forApprove" })) {
                    if (["waitReceive", "waitApprove"].includes(record.refStatus?.key)) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canArchive: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canArchive" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canDelete: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canDelete" }) || record.isActive === false) return false;
            if (["draft"].includes(record.refStatus?.key)) {
                result = true || result;
            }
            return result;
        },
        canWaitApprove: ({ props, record }) => {
            let result = false;
            const { menuContext, routerPrefix } = props;
            if (routerPrefix === "release-results") {
                if (has({ menuContext, key: "forReceive" })) {
                    if (["waitReleaseResult", "reEditAuthority"].includes(record.refStatus?.key)) {
                        result = true || result;
                    }
                }
            }
            if (["release-requests", "releases"].includes(routerPrefix)) {
                if (has({ menuContext, key: "forReceive" })) {
                    if (["waitRelease", "reEditAuthority"].includes(record.refStatus?.key)) {
                        result = true || result;
                    }
                }
            }
            if (routerPrefix === "release-cancels") {
                if (has({ menuContext, key: "forRequest" })) {
                    if (["draft", "waitRelease", "reEditAuthority"].includes(record.refStatus?.key)) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canApprove: ({ props, record }) => {
            let result = false;
            const { menuContext, routerPrefix } = props;
            const userInfo = store.state.resource.auth.info?.user;
            if (routerPrefix === "release-results") {
                if (has({ menuContext, key: "forApprove" })) {
                    if (["waitApprove"].includes(record.refStatus?.key) && !record.refReleaseTemp?.isApproveResult) {
                        if (record.refToApproveBy?.username === userInfo.username) {
                            result = true || result;
                        }
                    }
                }
            }
            if (["release-requests", "release-cancels"].includes(routerPrefix)) {
                if (has({ menuContext, key: "forApprove" })) {
                    if (["waitApprove"].includes(record.refStatus?.key) && record.refReleaseTemp?.isApproveResult) {
                        if (record.refToApproveBy?.username === userInfo.username) {
                            result = true || result;
                        }
                    }
                }
            }
            return result;
        },
        canAcknowledge: ({ props, record }) => {
            let result = false;
            const { menuContext, routerPrefix } = props;
            if (routerPrefix === "releases") {
                if (has({ menuContext, key: "forRequest" })) {
                    if (["waitCompanyAcknowledge"].includes(record.refStatus?.key) && record.refReleaseTemp?.isApproveResult) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canReStatus: ({ props, record }) => {
            let result = false;
            const { menuContext, routerPrefix } = props;
            if (routerPrefix === "release-results") {
                if (has({ menuContext, key: "forReceive" })) {
                    if (["waitApprove"].includes(record.refStatus?.key) && !record.refReleaseTemp?.isApproveResult) {
                        result = true || result;
                    }
                }
            }
            if (["release-requests", "releases"].includes(routerPrefix)) {
                if (has({ menuContext, key: "forReceive" })) {
                    if (["waitApprove"].includes(record.refStatus?.key) && record.refReleaseTemp?.isApproveResult) {
                        result = true || result;
                    }
                }
            }
            if (routerPrefix === "release-cancels") {
                if (has({ menuContext, key: "forRequest" })) {
                    if (["waitApprove"].includes(record.refStatus?.key) && record.refReleaseTemp?.isApproveResult) {
                        result = true || result;
                    }
                }
            }
            return result;
        },
        canSendNsw: ({ props, record }) => {
            let result = false;
            const { menuContext, routerPrefix } = props;
            if (routerPrefix === "release-results") {
                if (record.refReleaseTemp?.isApproveResult) {
                    if (have({ menuContext, keys: ["forReceive", "forApprove"] })) {
                        if (!record.isNswProcess2 && (!record.nswMessage2Id || ["REJECT", "ERROR", "OGAInspectionResultError"].includes(record.nswOgaResponseMessageType))) {
                            result = true || result;
                        }
                    }
                }
            }
            if (["release-requests"].includes(routerPrefix)) {
                if (["approve"].includes(record.refStatus?.key)) {
                    if (have({ menuContext, keys: ["forReceive", "forApprove"] })) {
                        if (!record.isNswProcess && (!record.nswMessageId || ["REJECT", "ERROR", "OGAInspectionResultError"].includes(record.nswLicenseResponseMessageType))
                            && record.refReleaseTemp?.refInspection?.refInformTemp?.refOperation?.key === "1"
                        ) {
                            result = true || result;
                        }
                    }
                }
            }
            return result;
        },
    };
};

export const createConditionFormResult = () => {
    return [
        {
            check: ({ field }) => {
                return ["refReleaseTemp.resultRemark"].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitRelease",
                    "waitApprove",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^refReleaseTemp\\.products\\.[^\\.]+\\.(refResult)$`, "g").test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitRelease",
                    "waitApprove",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["4"]
            })
        },
    ];
};

export const createConditionFormRelease = () => {
    return [
        {
            check: ({ field }) => {
                return ["refRequestType"].includes(field?.key);
            },
            visibleField: ({ props }) => {
                const { routerPrefix } = props;
                return routerPrefix !== "release-results";
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitApprove",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refRelease",].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["4"].includes(modelRef.refRequestType?.key) || modelRef.refRelease;
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitApprove",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
        {
            check: ({ field }) => {
                return [
                    "refReleaseTemp.refInspection.approveCode2",
                    "refReleaseTemp.refInspection.refRequestDoc2",
                    "refReleaseTemp.refInspection.approveCode2",
                ].includes(field?.key);
            },
            visibleField: ({ props }) => {
                const { routerPrefix } = props;
                return routerPrefix === "release-results";
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refReleaseTemp.releaseDate",
                    "refReleaseTemp.refValidateDocStatus",
                    "refReleaseTemp.refOpenInspectionResult",
                ].includes(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitApprove",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["4"]
            })
        },
        {
            check: ({ field }) => {
                return [
                    "refReleaseTemp.refInspection.refInformTemp.refExportCheckpoint2.nameTh",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["18", "19"].includes(modelRef.refReleaseTemp?.refInspection?.refRequestDoc?.key);
            },
        },
        {
            check: ({ field }) => {
                return ["refReleaseTemp.validateDocRemark"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["3"].includes(modelRef.refReleaseTemp?.refValidateDocStatus?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitApprove",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refReleaseTemp.refInspectionIncorrectResult"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["2"].includes(modelRef.refReleaseTemp?.refOpenInspectionResult?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitApprove",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refReleaseTemp.inspectionIncorrectRemark"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["3"].includes(modelRef.refReleaseTemp?.refInspectionIncorrectResult?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitApprove",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["4"]
            })
        },
        {
            check: ({ field }) => {
                return ["refReleaseTemp.refSequestrate"].includes(field?.key);
            },
            inputPropField: ({ props, modelRef }) => {
                const { viewOnly } = props;
                let enabled = !viewOnly;
                if (["1"].includes(modelRef.refReleaseTemp?.refInspection?.refSequestrate?.key)) {
                    enabled = false;
                }
                if (["4"].includes(modelRef.refRequestType?.key)) {
                    enabled = false;
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(`^refReleaseTemp\\.refInspection\\.refInformTemp\\.products\\.[^\\.]+\\.isCheck$`, "g").test(field?.key);
            },
            visibleField: () => true
        },
        {
            check: ({ field }) => {
                return ["remark"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["notApprove"].includes(modelRef.refStatus?.key)
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(`^refReleaseTemp\\.refInspection\\.refInformTemp\\.products\\.[^\\.]+\\.isSequestrate$`, "g").test(field?.key);
            },
            visibleField: () => true,
            checkboxField: ({ props, initialModel, modelRef }) => {
                const { viewOnlyInspection } = props;
                let enabled = !viewOnlyInspection;
                if (["waitApprove", "approve", "notApprove", "cancel"].includes(initialModel.refStatus?.key)) {
                    enabled = false;
                }
                if (!modelRef.refReleaseTemp?.refInspection?.isInspect) {
                    enabled = false;
                }
                if (modelRef.refReleaseTemp?.refResult?.key !== "3" && modelRef.refReleaseTemp?.refSequestrate?.key !== "1") {
                    enabled = false;
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(`^refReleaseTemp\\.refInspection\\.refInformTemp\\.products\\.[^\\.]+\\.isSampling$`, "g").test(field?.key);
            },
            visibleField: () => {
                return true
            },
            checkboxField: ({ props, initialModel, modelRef }) => {
                const { viewOnlyInspection } = props;
                let enabled = !viewOnlyInspection;
                if (["waitApprove", "approve", "notApprove", "cancel"].includes(initialModel.refStatus?.key)) {
                    enabled = false;
                }
                if (!modelRef.refReleaseTemp?.refInspection?.isInspect) {
                    enabled = false;
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["refReleaseTemp.refOpenInspection.inspectionDatetime"].includes(field?.key);
            },
            inputPropField: ({ props }) => {
                const { viewOnly } = props;
                let enabled = !viewOnly;
                return { disabled: !enabled };
            }
        },
        {
            check: ({ componentKey }) => {
                return ["ReleaseOfficerList"].includes(componentKey);
            },
            visibleField: ({ modelRef }) => {
                return !!modelRef.refRequestType?.key;
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                let enabled = !viewOnly;
                const common = commonInputPropField({
                    disabledStatuses: ["waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: ["4"]
                })({ modelRef, initialModel });
                if (common.disabled) {
                    enabled = false;
                }
                return { disabled: !enabled, canCreate: enabled, canDelete: enabled };
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(`^refReleaseTemp\\.officers\\.[^\\.]+\\.(refUser|tel)$`, "g").test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitApprove",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^refReleaseTemp\\.openInspections\\.[^\\.]+\\.(inspectionDatetime|refTransportByWay|vehicleNo|netWeight|refNetWeightUnit|qty|refQtyUnit|qtySampling|refQtySamplingUnit|boxNo|sealNo)$`, "g").test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    "waitApprove",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: ["4"]
            })
        },
        {
            check: ({ field }) => {
                return new RegExp(`^refReleaseTemp\\.refInspection\\.refInformTemp\\.products\\.[^\\.]+\\.sequestrates\\.[^\\.]+\\.addresses\\.[^\\.]+\\.(refAddressType|latitude|longitude|map)$`, "g").test(field?.key);
            },
            visibleField: () => {
                return false
            },
        },
        {
            check: ({ field }) => {
                const regExps = [
                    new RegExp(`^refReleaseTemp\\.refInspection\\.refInformTemp\\.products\\.[^\\.]+\\.samplings\\.[^\\.]+\\.distributor$`, "g"),
                ];
                return regExps.some(d => d.test(field?.key));
            },
            visibleField: ({ modelRef, field }) => {
                const samplingKey = field?.key.replace(".distributor", "");
                const sampling = lodash.get(modelRef, samplingKey);
                if (sampling?.distributors?.length) {
                    return false
                }
                return true;
            },
        },
        {
            check: ({ componentKey }) => {
                return new RegExp(`^SamplingDistributorList`, "g").test(componentKey);
            },
            visibleField: ({ modelRef, field }) => {
                const samplingKey = field?.key.replace(".distributor", "");
                const sampling = lodash.get(modelRef, samplingKey);
                if (sampling?.distributors?.length) {
                    return true
                }
                return false;
            },
        },
        {
            check: ({ componentKey }) => {
                return new RegExp(`^SequestrateInfoForm`, "g").test(componentKey);
            },
            visibleField: ({ model }) => {
                return model?.isSequestrate;
            }
        },
        {
            check: ({ componentKey }) => {
                return new RegExp(`^SamplingInfoForm`, "g").test(componentKey);
            },
            visibleField: ({ model }) => {
                return model?.isSampling;
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forRequestRemark.0.remark"].includes(field?.key);
            },
            visibleField: ({ props }) => {
                const { routerPrefix } = props;
                return routerPrefix !== "release-results";
            },
            inputPropField: ({ modelRef, initialModel }) => {
                const common = commonInputPropField({
                    disabledStatuses: ["waitReceive", "waitApprove", "approve", "notApprove", "cancel"],
                    disabledRequestTypes: []
                })({ modelRef, initialModel });
                return common;
            }
        },
        {
            check: ({ field }) => {
                return ["lastStatus.forApproveRemark.0.remark"].includes(field?.key);
            },
            visibleField: ({ props }) => {
                const { routerPrefix } = props;
                return routerPrefix !== "release-results";
            },
            inputPropField: commonInputPropField({
                disabledStatuses: [
                    undefined,
                    "draft",
                    "waitRelease",
                    "reEditOfficer",
                    "reEditAuthority",
                    "approve",
                    "notApprove",
                    "cancel"
                ],
                disabledRequestTypes: []
            })
        },
    ];
};
